export default __webpack_public_path__ + "static/media/MobileCoding.92e57be4.svg";